import { validatePhoneNumber } from "../../componets/ValidationError";

export var Edit_Application_Validator = {
    extract_registration_biograph: (voter, type) => {

        return {
            name: voter[type]?.name || '',
            surname: voter[type]?.surname || '',
            middlename: voter[type]?.middlename || '',
            dateOfBirth: new Date(voter[type]?.dateOfBirth)?.toISOString() || '',
            email: voter[type]?.email || null,
            genderID: voter[type]?.genderID || null,
            disabilityID: voter[type]?.disabilityID,
            villageID: voter?.village?.villageID,
        };
    },
    extract_amendment_biograph: (voter, type) => {
        return {
            name: voter[type]?.name || '',
            surname: voter[type]?.surname || '',
            middlename: voter[type]?.middlename || '',
            dateOfBirth: new Date(voter[type]?.dateOfBirth)?.toISOString() || '',
            email: voter[type]?.email || null,
            genderID: voter[type]?.genderID || null,
            disabilityID: voter[type]?.disabilityID,
            villageID: voter?.village?.villageID,
        };
    },


    extract_contact_details: (voter, type) => {
        return {
            cellPhone1: voter[type]?.cellPhone1?.number || null,
            cellPhone2: voter[type]?.cellPhone2?.number || null,
            cellPhone1CountryCodeID: voter[type]?.cellPhone1?.countryCodeID || null,
            cellPhone2CountryCodeID: voter[type]?.cellPhone2?.countryCodeID || null,
        };
    },

    extract_dermacation: (voter, type) => {
        return {
            villageID: voter?.village?.villageID,
        };
    },

    object_are_different: (obj1, obj2) => {
        return JSON.stringify(obj1) !== JSON.stringify(obj2);
    },

    have_binary_data_dermacation: (binary_data = []) => {
        return binary_data?.length > 0;
    },

    amendment_validation: (type, new_voter, old_voter, binary_data, toast, referralReasons = []) => {
        const newContact = Edit_Application_Validator.extract_contact_details(new_voter, type);
        var res = [
            !validatePhoneNumber(newContact.cellPhone1, newContact.cellPhone1CountryCodeID, true).valid,
            !validatePhoneNumber(newContact.cellPhone2, newContact.cellPhone2CountryCodeID, true).valid
        ]
        if (res.includes(true)) {
            toast.show({
                severity: "error",
                detail: `Please fill in all required fields`,
                life: 6000
            });
            return false;
        }
        return true;
    },
    registration_validation: (type, new_voter, old_voter, binary_data, toast, referralReasons = []) => {
        const newContact = Edit_Application_Validator.extract_contact_details(new_voter, type);

        var res = [
            !validatePhoneNumber(newContact.cellPhone1, newContact.cellPhone1CountryCodeID).valid,
            !validatePhoneNumber(newContact.cellPhone2, newContact.cellPhone2CountryCodeID, true).valid
        ]
        if (res.includes(true)) {
            toast.show({
                severity: "error",
                detail: `Please fill in all required fields`,
                life: 6000
            });
            return false;
        }
        return true;
    },

    registration_biographic: (type, new_voter, old_voter, binary_data, toast, referralReasons = []) => {


        for (let i = 0; i < referralReasons.length; i++) {
            const reason = referralReasons[i]; // full object: { id, name }
            switch (reason.referralReasonID) {
                case 3: // Application Form Image
                    if (!Edit_Application_Validator.have_binary_data_dermacation(binary_data)) {
                        toast.show({
                            severity: "error",
                            detail: `${reason.referralReason} is required`,
                            life: 6000
                        });
                        return false;
                    }
                    break;

                case 1: // Biographic Details
                    const newBio = Edit_Application_Validator.extract_registration_biograph(new_voter, type);
                    const oldBio = Edit_Application_Validator.extract_registration_biograph(old_voter, type);
                    if (!Edit_Application_Validator.object_are_different(newBio, oldBio)) {
                        toast.show({
                            severity: "error",
                            detail: `No change has been made to ${reason.referralReason}`,
                            life: 6000
                        });
                        return false;
                    }
                    break;

                case 2: // Demarcation Details
                    const newDemarcation = Edit_Application_Validator.extract_dermacation(new_voter, type);
                    const oldDemarcation = Edit_Application_Validator.extract_dermacation(old_voter, type);

                    if (!Edit_Application_Validator.object_are_different(newDemarcation, oldDemarcation)) {
                        toast.show({
                            severity: "error",
                            detail: `No change has been made to ${reason.referralReason}`,
                            life: 6000
                        });
                        return false;
                    }
                    break;

                case 4: // Contact Details
                    const newContact = Edit_Application_Validator.extract_contact_details(new_voter, type);
                    const oldContact = Edit_Application_Validator.extract_contact_details(old_voter, type);

                    var res = [
                        !validatePhoneNumber(newContact.cellPhone1, newContact.cellPhone1CountryCodeID).valid,
                        !validatePhoneNumber(newContact.cellPhone2, newContact.cellPhone2CountryCodeID, true).valid
                    ]
                    if (res.includes(true)) {
                        toast.show({
                            severity: "error",
                            detail: `Please fill in all required fields`,
                            life: 6000
                        });
                        return false;
                    }
                    if (!Edit_Application_Validator.object_are_different(newContact, oldContact)) {
                        toast.show({
                            severity: "error",
                            detail: `No change has been made to ${reason.referralReason}`,
                            life: 6000
                        });
                        return false;
                    }
                    break;
            }
        }

        return true;
    },

    amendment_biographic: (type, new_voter, old_voter, binary_data, toast, referralReasons = []) => {
        const newContact = Edit_Application_Validator.extract_contact_details(new_voter, type);
        var res = [
            !validatePhoneNumber(newContact.cellPhone1, newContact.cellPhone1CountryCodeID).valid,
            !validatePhoneNumber(newContact.cellPhone2, newContact.cellPhone2CountryCodeID, true).valid
        ]

        if (res.includes(true)) {
            toast.show({
                severity: "error",
                detail: `Please fill in all required fields`,
                life: 6000
            });
            return false;
        }
        console.log(referralReasons)
        for (let i = 0; i < referralReasons.length; i++) {
            const reason = referralReasons[i]; // full object: { id, name }
            switch (reason.referralReasonID) {
                case 3: // Application Form Image
                    if (!Edit_Application_Validator.have_binary_data_dermacation(binary_data)) {
                        toast.show({
                            severity: "error",
                            detail: `${reason.referralReason} is required`,
                            life: 6000
                        });
                        return false;
                    }
                    break;

                case 1: // Biographic Details
                    const newBio = Edit_Application_Validator.extract_amendment_biograph(new_voter, type);
                    const oldBio = Edit_Application_Validator.extract_amendment_biograph(old_voter, type);
                    if (!Edit_Application_Validator.object_are_different(newBio, oldBio)) {
                        toast.show({
                            severity: "error",
                            detail: `No change has been made to ${reason.referralReason}`,
                            life: 6000
                        });
                        return false;
                    }
                    break;

                case 2: // Demarcation Details
                    const newDemarcation = Edit_Application_Validator.extract_dermacation(new_voter, type);
                    const oldDemarcation = Edit_Application_Validator.extract_dermacation(old_voter, type);
                    if (!Edit_Application_Validator.object_are_different(newDemarcation, oldDemarcation)) {
                        toast.show({
                            severity: "error",
                            detail: `No change has been made to ${reason.referralReason}`,
                            life: 6000
                        });
                        return false;
                    }
                    break;

                case 4: // Contact Details
                    const newContact = Edit_Application_Validator.extract_contact_details(new_voter, type);
                    const oldContact = Edit_Application_Validator.extract_contact_details(old_voter, type);
                    var res = [
                        !validatePhoneNumber(newContact.cellPhone1, newContact.cellPhone1CountryCodeID).valid,
                        !validatePhoneNumber(newContact.cellPhone2, newContact.cellPhone2CountryCodeID, true).valid
                    ]
                    if (res.includes(true)) {
                        toast.show({
                            severity: "error",
                            detail: `Please fill in all required fields`,
                            life: 6000
                        });
                        return false;
                    }
                    if (!Edit_Application_Validator.object_are_different(newContact, oldContact)) {
                        toast.show({
                            severity: "error",
                            detail: `No change has been made to ${reason.referralReason}`,
                            life: 6000
                        });
                        return false;
                    }
                    break;
            }
        }

        return true;
    }
};
